let ryplStartPosLeft = 0;
let ryplStartPosRight = 0;
let ryplStep = 1;
let ryplTotalSteps = document.getElementsByClassName('rypl-step-left').length;

// ---------------------------------------------------------- Products Nav //
const productsNavAnim = {
  elms: [
  '#products-nav',
  ],
};

buildScenes(productsNavAnim);

$('body').on('click', '#products-nav li, .btn-reporting, .btn-delivery', function(e) {
  e.preventDefault();
  const name = $(this).data('name');
  subPageName = name;

  $('#products-nav li').removeClass('active');
  $(`li[data-name="${name}"`).addClass('active');

  if (!mobileAndTabletCheck()) {
    pageDownScroll('smooth', window.innerHeight);
  }

  getSubPage(name);
});

// ---------------------------------------------------------- Get Sub-Page //
let subPageName;

const getSubPage = function(pageName) {
  if (subPid !== pageName) {
    $('.loader').css('display', 'block');
    $('.products-sub-pages .sub-container').css('display', 'none');

    $.ajax({
      url: '/ajax/products/get_sub_page',
      type: 'POST',
      dataType: 'json',
      data: { pageName },
    })
    .done(response => {
      subPageName = pageName;
      subPid = pageName;

      $('.loader').css('display', 'none');
      $('.products-sub-pages .sub-container').html(response.data).css('display', 'block');
      $('.sub-page').attr('id', `${pageName}-sub-page`);

      scrollMagicController.destroy(`#${subPid}-sub-page > div`);

      if (pageName === 'rypl') {
        ryplStartPosLeft = 0;
        ryplStartPosRight = 0;
        ryplStep = 1;
        ryplTotalSteps = document.getElementsByClassName('rypl-step-left').length;

        scrollMagicController.destroy('.how-it-works-container');

        if (mobileAndTabletCheck()) {
          $('.how-it-works-container').addClass('active');
        }

        ryplAnimations();
      }

      subPageAnimations(subPageName);

      // Update page URL //
      window.history.replaceState(pageName, pageName, `/products/${pageName}`);
    })
    .fail(response => {
      console.error('error', response);
    });
  }
};

// ---------------------------------------------------------- Sub-Page Animations Activate //
function subPageAnimations(subPid) {
  const channelAnim = {
    elms: [
    `#${subPid}-sub-page > div`,
    ],
    delay: 500,
  };

  buildScenes(channelAnim);
}

subPageAnimations(subPid);

// ---------------------------------------------------------- CHANNELS SUB PAGE //

// ----------------------------- Accordion //
let channelsTopTitle;

$('body').on('click', '.channels-accordion .tile', function() {
  const copyTitle = $(this).data('title');
  channelsTopTitle = $(this).children().find('.top .title');

  // Remove animation classes so regular transitions are not affected //
  $('.tile').removeClass('a1 a2 a3 a4 a5 a6 a7');

  $('.top .title').removeClass('vis enter');
  $('.channels-accordion .tile').removeClass('open');
  $(this).addClass('open');

  $('#channels-sub-page .copy-container').removeClass('vis');
  $(`#channels-sub-page .${copyTitle}-copy`).addClass('vis');
});

// ---------------------------------------------------------- RYPL SUB PAGE //

// ----------------------------- Rypl Nav //
$('body').on('click', '#rypl-nav span', function() {
  const direction = $(this).data('dir');
  const stepsWidthLeft = document.getElementById('rypl-steps-left').offsetWidth;
  const stepsWidthRight = document.getElementById('rypl-steps-right').offsetWidth;

  $(`.step-${ryplStep}`).add(`.dot-${ryplStep}`).removeClass('active');

  // Step back //
  if (direction === 'back' && ryplStep > 1) {
    $('#rypl-steps-left').css('left', ryplStartPosLeft + stepsWidthLeft);
    $('#rypl-steps-right').css('left', ryplStartPosRight + stepsWidthRight);
    ryplStartPosLeft += stepsWidthLeft;
    ryplStartPosRight += stepsWidthRight;
    ryplStep -= 1;
  }

  // Step forward //
  if (direction === 'fwd' && ryplStep < ryplTotalSteps) {
    $('#rypl-steps-left').css('left', ryplStartPosLeft - stepsWidthLeft);
    $('#rypl-steps-right').css('left', ryplStartPosRight - stepsWidthRight);
    ryplStartPosLeft -= stepsWidthLeft;
    ryplStartPosRight -= stepsWidthRight;
    ryplStep += 1;
  }

  $(`.step-${ryplStep}`).add(`.dot-${ryplStep}`).addClass('active');
});

$('body').on('mouseenter', '#rypl-nav span', () => {
  $('#rypl-nav span').removeClass('pulse');
});

// ----------------------------- How it Works Animation and Play //
function ryplAnimations() {
  const howItWorksAnim = {
    elms: [
    '.how-it-works-container',
    ],
    offset: 10,
  };

  buildScenes(howItWorksAnim);
}

if (subPid === 'rypl') {
  ryplAnimations();
}

if (mobileAndTabletCheck()) {
  $('.how-it-works-container').addClass('active');
}
